import styled from 'styled-components';
import { tokens, palette } from '../../styles';

/**
 * Just a wrapper to ensure that the tables wrapped by it
 * would be properly formatted according to our design system
 */
export const TableWrapper = styled.div`
  table {
    ${tokens.font.s};

    background-color: ${palette['color-white']};
    width: 100%;
    text-align: left;
    table-layout: fixed;
    border-collapse: collapse;
    border-radius: ${tokens.borderRadius};
  }

  tr {
    border-bottom: 1px solid ${palette['color-grey-300']};

    &:last-child {
      border-bottom: 0;
    }
  }

  th {
    ${tokens.font['xs-emphasys']};
    text-transform: uppercase;
  }

  th,
  td {
    padding: ${tokens.spacing.m};

    &:first-child {
      padding-left: ${tokens.spacing.xl};
    }
    &:last-child {
      padding-right: ${tokens.spacing.xl};
    }
  }
`;
